import React from 'react';
import NotificationRuleDetailSection from '../../../sections/AdminDashboard/Configuration/NotificationRuleDetail';

const NotificationRuleDetail = () => {
  return <NotificationRuleDetailSection />;
};

export default NotificationRuleDetail;
